import styled from 'styled-components';

import { Colors } from 'environment';

export const Line = styled.div`
	height: 0.1rem;
	background-color: ${Colors.background.disabled};
`;
